import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
// import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
// import { FlyoutLoggedinUserComponent } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.component';
import { FlyoutLoggedinUserModule } from '../../flyout/flyout-loggedin-user/flyout-loggedin-user.module';
// This Module's Components
import { SwitchingAccountComponent } from './switching-account.component';
import { SwitchingAccountService } from './switching-account.service';

@NgModule({
  imports: [CommonModule, FlyoutLoggedinUserModule],
  declarations: [SwitchingAccountComponent],
  exports: [SwitchingAccountComponent],
  providers: [SwitchingAccountService]
})
export class SwitchingAccountModule {}
